'use client';

import { c as _c } from "react/compiler-runtime";
import { Icon, Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui';
import { Alert } from '@repo/ui/icons';
import { memo } from 'react';
const VaultV2MaxRateWarning = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Tooltip><TooltipTrigger asChild={true}><Icon className="text-warning-foreground" icon={<Alert />} /></TooltipTrigger><TooltipContent>The vault allocator has capped the rate at 0%. This vault V2 doesn't accrue native interest.</TooltipContent></Tooltip>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(VaultV2MaxRateWarning);